"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_router_dom_1 = require("react-router-dom");
const ProductList_1 = require("./ProductList");
const BrandList_1 = require("./BrandList");
const ProductDisplay_1 = require("./ProductDisplay");
const Product_1 = require("./Models/Product");
const Brand_1 = require("./Models/Brand");
const Category_1 = require("./Models/Category");
const Store_1 = require("./Store");
require("jquery");
class ProductsApp extends React.Component {
    constructor(props) {
        super(props);
        Store_1.default.containerId = this.props.containerId;
        Store_1.default.currentPageName = this.props.currentPageName;
        Store_1.default.containerUrlSegment = this.props.containerUrlSegment;
        Store_1.default.Translations = this.props.translations;
        Store_1.default.BackgroundImageUrl = this.props.backgroundImageUrl;
        Store_1.default.DimFilter = this.props.dimFilter || false;
        Store_1.default.currentLanguage = this.props.currentLanguage;
        Store_1.default.disableBrands = this.props.disableBrands || false;
        Store_1.default.disableCategories = this.props.disableCategories || false;
        if (this.props.selectedProduct !== null) {
            Store_1.default.SelectedProduct = new Product_1.default({ id: this.props.selectedProduct });
            Store_1.default.SelectedProduct.loadDetails();
            Store_1.default.loadBrands();
            Store_1.default.loadCategories();
        }
        if (this.props.selectedBrand !== null) {
            Store_1.default.SelectedBrand = new Brand_1.default(this.props.selectedBrand);
            Store_1.default.loadProducts();
        }
        else if (this.props.selectedCategories !== null && this.props.selectedCategories.length > 0) {
            Store_1.default.SelectedCategories.replace(this.props.selectedCategories.map(json => new Category_1.default(json)));
            Store_1.default.loadProducts();
        }
        window.onpopstate = function () {
            location.reload();
        };
    }
    render() {
        return (React.createElement(react_router_dom_1.BrowserRouter, null,
            React.createElement(react_router_dom_1.Switch, null,
                React.createElement(react_router_dom_1.Route, { exact: true, path: Store_1.default.containerUrlSegment, component: Store_1.default.disableBrands ? ProductList_1.default : BrandList_1.default }),
                Store_1.default.disableBrands && React.createElement(react_router_dom_1.Route, { path: Store_1.default.containerUrlSegment + ":categories/:product", component: ProductDisplay_1.default }),
                Store_1.default.disableBrands && Store_1.default.disableCategories && React.createElement(react_router_dom_1.Route, { path: Store_1.default.containerUrlSegment + ":product", component: ProductDisplay_1.default }),
                React.createElement(react_router_dom_1.Route, { path: Store_1.default.containerUrlSegment + ":categories/:brand/:product", component: ProductDisplay_1.default }),
                React.createElement(react_router_dom_1.Route, { path: Store_1.default.containerUrlSegment + ":categories", component: ProductList_1.default }))));
    }
}
exports.default = ProductsApp;
